import { render } from "./PROPOSAL_COMMITTEE_DECISION.vue?vue&type=template&id=c531cf4e"
import script from "./PROPOSAL_COMMITTEE_DECISION.vue?vue&type=script&lang=js"
export * from "./PROPOSAL_COMMITTEE_DECISION.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__